import { render } from "./VendorSearch.vue?vue&type=template&id=4fa9358c"
import script from "./VendorSearch.vue?vue&type=script&lang=js"
export * from "./VendorSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__